import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'auto-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  currentDate = new Date().getFullYear();

  constructor() { }

  ngOnInit() {
  }

}
